import { z } from 'zod';
export const slmStatusSchema = z.enum(['NOT_SENT', 'WAITING', 'RECEIVED']);
export const slmSupplierSchema = z.enum(['M', 'P']);
export const SLM_SUPPLIERS = [{ value: 'M', label: 'SLM-M — ОРТОС, Москва' }, { value: 'P', label: 'SLM-P — Парилов' }];
export function slmKind(c) {
    if (!c?.hasSlm)
        return null;
    if (/кольц/iu.test(c.name ?? ''))
        return 'ring';
    if (/haas|хаас|marpe|sarpe|марпе|сарпе|марко.*рос/iu.test(c.name ?? ''))
        return 'appliance';
    return null;
}
export function defaultSlmSupplier(c) {
    return slmKind(c) === 'ring' ? 'P' : 'M';
}
export function slmBaseExpense(c, supplier) {
    if (slmKind(c) === 'appliance')
        return (supplier ?? defaultSlmSupplier(c)) === 'P' ? 580000 : 530000;
    if (slmKind(c) === 'ring')
        return 50000;
    return c?.costKop ?? 0;
}
export const SLM_OPTIONS = [
    { value: 'NOT_SENT', label: 'Не отправлен в печать' },
    { value: 'WAITING', label: 'Отправлен — ждём каркас' },
    { value: 'RECEIVED', label: 'Каркас пришёл' },
];
//# sourceMappingURL=slm.js.map